let recaptcha = null;
let callbacks = [];

// Global listener defined in the url of the recaptcha script tag
window.recaptchaLoaded = () => {
    recaptcha = window.grecaptcha;

    callbacks.forEach((callback) => {
        callback(recaptcha);
    });

    callbacks = [];
};

export function getRecaptcha() {
    return new Promise((resolve) => {
        if (recaptcha) {
            return resolve(recaptcha);
        }

        callbacks.push(resolve);
    });
}



// WEBPACK FOOTER //
// ./assets/js/lib/recaptcha.js